import {RootState} from "../../../../store/rootReducer";

export const plusMenuSelector = (state: RootState) => ({
   isMenuOpen: state.cardEditor.isPlusMenuOpen,
});
